export function removeDuplicates(array, property) {
    const seen = new Set();
    return array.filter(obj => {
        const value = obj[property];
        if (seen.has(value)) {
            return false; // Duplicate, filter it out
        }
        seen.add(value);
        return true; // Not a duplicate, keep it
    });
}

export function allowNumbersOnly (e) {
    let code = (e.which) ? e.which : e.keyCode;
    if (code > 31 && (code < 48 || code > 57)) {
        e.preventDefault();
    }
}